
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeSarFilled as ObiVesselTypeSarFilledElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-sar-filled.js';
 
 
 

 
 export const ObiVesselTypeSarFilled = createComponent({
   react: React,
   tagName: 'obi-vessel-type-sar-filled',
   elementClass: ObiVesselTypeSarFilledElement,
   events: {
     
   }
  });
 
 